import React from "react"
import posed, { PoseGroup} from 'react-pose'
import styled from 'styled-components'
import { Link } from "gatsby"

const NavPose = posed.nav({
  open: {
    delayChildren: 1000,
    staggerChildren: 100,
  },
  closed: {
    staggerChildren: 100,
  }
});

const Nav = styled(NavPose)`
  li {
   width: min-content;
   display: inline-block;
   :last-child {
     margin-bottom: 0;
     padding-right: 0;
   }
   @media (min-width: 1024px) {
     display: list-item;
   }
  }
`

const Ul = styled.ul`
  list-style-type: square;
  color: white;
  margin-left: 0;
  a {
    text-decoration: none;
    text-transform: uppercase;
    letter-spacing: 2px;
  }
  @media (min-width: 1024px) {
    margin-left: 2rem;
  }
`

const Li = posed.li({
  open: {
    x: 0,
    opacity: 1
  },
  closed: {
    x: -20,
    opacity: 0
  },
  hoverable: true,
  init: { scale: 1 },
  hover: { scale: 1.2, x: 10 }
});

class Menu extends React.Component {
  state = { isVisible: false };

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        isVisible: !this.state.isVisible
      });
    }, 2500);
  }

  render() {
    const { className, isOpen } = this.props;

    return(
      <Nav className={className} pose={isOpen ? 'open' : 'closed'}>
        <Ul>
          <Li className="pr-3">
            <Link
              className="text-white font-mono text-base lg:text-lg"
              to="/"
              activeStyle={{ textDecoration: "underline" }}>
              Home
            </Link>
          </Li>
          <Li className="pr-3">
            <Link
              className="text-white font-mono text-base lg:text-lg"
              to="/about/"
              activeStyle={{ textDecoration: "underline" }}>
              About
            </Link>
          </Li>
          <Li className="pr-3">
            <Link
              className="text-white font-mono text-base lg:text-lg"
              to="/services/"
              activeStyle={{ textDecoration: "underline" }}>
              Services
            </Link>
          </Li>
          <Li className="pr-3">
            <Link
              className="text-white font-mono text-base lg:text-lg"
              to="/knowledge/"
              activeStyle={{ textDecoration: "underline" }}>
              Knowledge
            </Link>
          </Li>
        </Ul>
      </Nav>
    )
  }
}

export default Menu;
